let helpers = {
    isNullOrEmpty: list => list == null && list.length == 0
}

let productCards = {
    init() {
        this.cards = document.querySelectorAll('.main-content .product-card');

        if (!helpers.isNullOrEmpty(this.cards)) {
            for (const card of this.cards) {
                let optionSelector = card.querySelector('.single-option-selector');
                let variantSelector = card.querySelector('.product-form__variants');
                let qty = card.querySelector('.product-form__input--quantity');

                if (optionSelector != null) {
                    optionSelector.addEventListener('change', e => {
                        let value = e.target.options[e.target.selectedIndex].text;

                        for (let option of variantSelector.options) {
                            if (option.text == value) {
                                option.selected = true;

                                card.dataset.originalPrice = option.dataset.price.replace('.', '');

                                if (qty != null) {
                                    qty.value = qty.min;
                                    this.quantity.init(card);
                                    
                                    this.updatePrice(card, card.dataset.originalPrice * parseInt(qty.min));
                                } else {
                                    this.updatePrice(card, card.dataset.originalPrice);
                                }

                                this.updateSku(card, option.dataset.sku);

                                break;
                            }
                        }
                    });
                }

                if (qty != null) {
                    this.quantity.init(card);
                    
                    this.updatePrice(card, card.dataset.originalPrice * parseInt(qty.min));
                } else {
                    this.updatePrice(card, card.dataset.originalPrice);
                }
            }
        }
    },
    
    quantity: {
        init(parent) {
            this.qtySelector = parent.querySelector(".quantity");

            if (this.qtySelector != null) {
                let input = this.qtySelector.querySelector("input");
                let qty = input.value;
    
                this.checkMinus(qty, input, this.qtySelector.querySelector(".minus"));
                this.checkPlus(qty, input, this.qtySelector.querySelector(".plus"));
    
                this.addEventListeners();
            }
        },
        addEventListeners() {
            let that = this;

            function handler(e) {
                if (!e.target.classList.contains('disabled')) {
                    let qtyNavParent = e.target.closest('.quantity');
                    const selector = qtyNavParent.querySelector(".product-form__input--quantity");
                    let value = parseInt(selector.value);
    
                    let thisCard = e.target.closest('.product-card');
                    let price = thisCard.dataset.originalPrice;
    
                    if (e.target.closest('div').classList.contains('minus')) {
                        value--;
                    } else {
                        value++;
                    }
    
                    productCards.updatePrice(thisCard, price * value);
    
                    selector.value = value;
                    that.checkMinus(value, selector, qtyNavParent.querySelector('.minus'));
                    that.checkPlus(value, selector, qtyNavParent.querySelector('.plus'));
                }
            }

            let selectors = this.qtySelector.querySelectorAll(".plus, .minus");

            for (let selector of selectors) {
                selector.onclick = handler;
            }
        },
        checkMinus(qty, input, elem) {
            let min = parseInt(input.min);
            let minus = this.minus;
    
            if (elem != null) {
                minus = elem;
            }
    
            if (qty <= min) {
                minus.classList.add("disabled");
            } else {
                minus.classList.remove("disabled");
            }
        },
        checkPlus(qty, input, elem) {
            let max = parseInt(input.max);
            let plus = this.plus;
    
            if (elem != null) {
                plus = elem;
            }
    
            if (max) {
                if (qty < max) {
                    plus.classList.remove("disabled");
                } else {
                    plus.classList.add("disabled");
                }
            }
        }
    },

    updatePrice(card, price) {
        let formattedPrice = theme.Currency.formatMoney(parseInt(price), theme.strings.moneyFormat);
        let priceElements = card.querySelectorAll('.price-item');
        let atcPrice = card.querySelector('.add-to-cart-button:not(.contact-for-price)');
        let cfPrice = card.querySelector('.contact-for-price');
        let priceIsZero = parseInt(price) == 0;

        if (!helpers.isNullOrEmpty(priceElements)) {
            for (const priceElement of priceElements) {
                if (priceIsZero) {
                    priceElement.style.display = 'none';
                } else {
                    priceElement.style.display = 'inline';
                    priceElement.innerHTML = formattedPrice;
                }
            }
        }

        if (atcPrice != null) {
            let innerSpan = atcPrice.querySelector('span');

            if (priceIsZero) {
                cfPrice.classList.remove('hide');
                atcPrice.classList.add('hide');
            } else {
                if (innerSpan != null) {
                    innerSpan.innerHTML = '&nbsp;-&nbsp;' + formattedPrice;
                } else {
                    atcPrice.innerHTML = 'Add to Cart&nbsp;-&nbsp;' + formattedPrice;
                }

                cfPrice.classList.add('hide');
                atcPrice.classList.remove('hide');
            }
        }
    },

    updateSku(card, sku) {
        let skus = card.querySelectorAll('.sku');

        if (skus.length > 0) {
            for (const skuElem of skus) {
                skuElem.innerHTML = sku;
            }
        }
    }
}

document.addEventListener('DOMContentLoaded', function() {
    productCards.init();
});